/**
 * @generated SignedSource<<94a158d834e24d856207d9536e435fe4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type incomeCurvesPage_PeriodsQuery$variables = Record<PropertyKey, never>;
export type incomeCurvesPage_PeriodsQuery$data = {
  readonly cacPaybackPeriods: ReadonlyArray<{
    readonly forecast: boolean;
    readonly paybackMonths: number | null | undefined;
    readonly signupMonth: string;
  }>;
};
export type incomeCurvesPage_PeriodsQuery = {
  response: incomeCurvesPage_PeriodsQuery$data;
  variables: incomeCurvesPage_PeriodsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "signupMonth",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paybackMonths",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "forecast",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "incomeCurvesPage_PeriodsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CacPaybackPeriod",
        "kind": "LinkedField",
        "name": "cacPaybackPeriods",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "incomeCurvesPage_PeriodsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CacPaybackPeriod",
        "kind": "LinkedField",
        "name": "cacPaybackPeriods",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b76a9209e6454acbfed1f2ee8b85b6fe",
    "id": null,
    "metadata": {},
    "name": "incomeCurvesPage_PeriodsQuery",
    "operationKind": "query",
    "text": "query incomeCurvesPage_PeriodsQuery {\n  cacPaybackPeriods {\n    signupMonth\n    paybackMonths\n    forecast\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "0b25f1760243c7b12fbeaa67ab51324a";

export default node;
